<nav
style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='%23666C84'/%3E%3C/svg%3E&#34;);"
aria-label="breadcrumb">
<ol class="breadcrumb">
  <li class="breadcrumb-item">
    <a  [routerLink]="['/home']">HOME </a>
  </li>
  <ng-container *ngFor="let breadcrumb of breadcrumbs; last as last; let i = index">
    <li *ngIf="!last" class="breadcrumb-item">
      <a (click)="GotoRoute(breadcrumb, i)" [ngStyle]="{'cursor':getCursor(breadcrumb.label)}">{{ breadcrumb.label | uppercase }}</a>
    </li>
    <li *ngIf="last" class="breadcrumb-item" >
     <a style="cursor:default;color:#9197b0;"> {{ breadcrumb.label | uppercase}}</a>
    </li>
  </ng-container>
</ol>
</nav>
